import { render, staticRenderFns } from "./Flipper.vue?vue&type=template&id=3c49772a"
import script from "./Flipper.vue?vue&type=script&lang=js"
export * from "./Flipper.vue?vue&type=script&lang=js"
import style0 from "./Flipper.vue?vue&type=style&index=0&id=3c49772a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports